import { useEffect, useState } from 'react'
import App from './App'
import { AboutPage } from './About'
import { Home } from './Home'
import { hasBadRoomIdInPath, rememberRoom, roomIdFromPath } from './room'

/**
 * `/`・`/r/<roomId>`・`/about` の振り分け。
 *
 * ルータは入れない。行き先が2つしか無いうえ、Phase 2（Discord Activity）では
 * URL がプロキシ配下に変わり、ルームIDの決定は room.ts に寄せてあるため。
 * → doc/sharing/master.md#実装
 */
export function Routes() {
  const [path, setPath] = useState(() => location.pathname)

  useEffect(() => {
    const onPop = () => setPath(location.pathname)
    window.addEventListener('popstate', onPop)
    return () => window.removeEventListener('popstate', onPop)
  }, [])

  const roomId = roomIdFromPath(path)

  useEffect(() => {
    if (roomId) rememberRoom(roomId)
  }, [roomId])

  // 権利表記と方針。**URL で指せることが要件**（→ doc/service/master.md#方針の明文化）
  if (path.replace(/\/$/, '') === '/about') return <AboutPage />

  // ルームが変われば盤面は別物。key で作り直して状態を持ち越さない
  return roomId ? <App key={roomId} roomId={roomId} /> : <Home badRoomId={hasBadRoomIdInPath(path)} />
}
